import {distributionWebsocketCommands} from '../../constants/distributionWebsocketCommands';
import {
    DISTRIBUTION_TICKET_CREATE,
    DISTRIBUTION_TICKET_UPDATE,
    DISTRIBUTION_TICKET_RESET, DISTRIBUTION_SUBSTITUTION_USER,
} from '../../actions/distribution/actionDistributionTicket';
import {DISTRIBUTION_ATTACHMENTS_UPLOADING_ERROR} from '../../actions/distribution/actionDistributionAttachment';
import {
    DISTRIBUTION_RESET_REDIRECT,
    DISTRIBUTION_SET_LOCK_TICKET
} from '../../actions/distribution/actionDistributionLockTicket';

export const distributionTicket = (state = {
    correlationId: null,
    isTicketLoading: false,
    isTicketCreating: false,
    created: false,
    ticket: {},
    logs: [],
    messages: {},
    attachments: [],
    newAttachments: [],
    substitutionUser: null,
}, action) => {
    switch (action.type) {
        case DISTRIBUTION_SUBSTITUTION_USER: {
            return Object.assign({}, state, {
                substitutionUser: action.payload
            });
        }
        case DISTRIBUTION_TICKET_UPDATE:
        case DISTRIBUTION_TICKET_CREATE: {
            const {newAttachments} = action.payload;
            return Object.assign({}, state, {
                newAttachments,
                isTicketCreating: true,
                created: false,
                isTicketLoading: true,
                logs: [],
                attachments: [],
                messages: {},
                substitutionUser: null,
            });
        }
        case DISTRIBUTION_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLoading: false,
                isTicketCreating: false,
                created: false,
                ticket: {},
                messages: {},
                logs: [],
                attachments: [],
                newAttachments: [],
                substitutionUser: null,
            });
        }
        //command accepted
        case distributionWebsocketCommands.DISTRIBUTION_TICKET_CREATED:
        case distributionWebsocketCommands.DISTRIBUTION_TICKET_UPDATED:
        case distributionWebsocketCommands.DISTRIBUTION_GET_TICKET: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketCreating: false,
                created: true,
                isTicketLoading: true,
                correlationId
            });
        }
        case distributionWebsocketCommands.DISTRIBUTION_TICKET_SEND: {
            const {ticket, correlationId, messages, logs, attachments, internalNotes, error} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            if (error) {
                return Object.assign({}, state, {isTicketLoading: false, correlationId});
            }
            return Object.assign({}, state, {
                isTicketLoading: false,
                correlationId,
                ticket,
                logs,
                attachments,
                messages,
                internalNotes,
            });
        }
        //att done + error
        case DISTRIBUTION_ATTACHMENTS_UPLOADING_ERROR:
        case distributionWebsocketCommands.DISTRIBUTION_ATTACHMENTS_SAVED_ERROR: {
            return Object.assign({}, state, {
                newAttachments: [],
            });
        }
        case distributionWebsocketCommands.DISTRIBUTION_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketLoading: true,
                correlationId,
                newAttachments: [],
            });
        }
        default:
            return state;
    }
};

export const distributionLockTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case distributionWebsocketCommands.DISTRIBUTION_TICKET_LOCKED_ERROR:
        case distributionWebsocketCommands.DISTRIBUTION_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case DISTRIBUTION_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case distributionWebsocketCommands.DISTRIBUTION_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case DISTRIBUTION_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
